import { ReactElement } from 'react';
import Dashboard from './dashboard.page';

/**
 * Public Dashboard Page - Accessible via token without authentication.
 * Authentication and validation is handled by PublicDataProvider context.
 * Uses the same Dashboard component as authenticated users via useUnifiedData hook.
 * @returns - A React element representing the public dashboard.
 */
export default function PublicDashboardPage(): ReactElement {
  return (
    <div className="bg-background-500 min-h-screen flex flex-col flex-1">
      <div className="p-4 h-full flex-1 flex-col flex">
        <Dashboard />
      </div>
    </div>
  );
}
